import {
  Box,
  Button,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { layoutCSS } from "../component/common/commonStyle";
import SearchIcon from "@mui/icons-material/Search";
import SettingsIcon from "@mui/icons-material/Settings";

const WabaNumber = () => {
  return (
    <Box sx={layoutCSS}>
      <Box
        fullwidth
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 2,
          mb: 2,
          p: 1,
          justifyContent: "flex-end",
        }}
      >
        <TextField
          placeholder="Search By WABA Number"
          size="small"
          sx={{
            width: 220,
            fontSize: "0.8rem",
            "& .MuiInputBase-input": {
              fontSize: "0.75rem",
              padding: "6px 8px",
            },
            "& .MuiInputLabel-root": {
              fontSize: "0.8rem",
            },
          }}
          InputProps={{
            startAdornment: (
              <span
                style={{
                  color: "#1e88e5",

                  marginRight: "4px",
                }}
              >
                <SearchIcon />
              </span>
            ),
          }}
        />
        <Button
          variant="contained"
          size="small"
          sx={{
            textTransform: "none", // keeps normal text case
            fontSize: 13,
            borderRadius: 1.5,
            px: 2, // horizontal padding
            py: 0.5, // vertical padding
          }}
        >
          Login By Facebook
        </Button>
      </Box>
      <Box
        fullwidth
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 2,
          mb: 2,
          p: 1,
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          backgroundColor: "#fafafa",
          justifyContent: "space-between ",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography
            sx={{
              fontSize: 14,
              color: "black",
              fontWeight: 700,
              fontStyle: "bold",
            }}
          >
            Filter by:
          </Typography>

          {/* Dropdown 1 */}
          <FormControl size="small" sx={{ width: 130 }}>
            <InputLabel
              id="demo-simple-select-label"
              sx={{ fontSize: "0.75rem" }}
            >
              WABA Number
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="WABA Number"
              sx={{
                fontSize: "0.75rem",
                "& .MuiInputBase-input": {
                  fontSize: "0.75rem",
                  padding: "6px 8px",
                },
              }}
            >
              <MenuItem value="91374673431">91374673431</MenuItem>
              <MenuItem value="91374673455">91374673455</MenuItem>
              <MenuItem value="91373217345">91373217345</MenuItem>
            </Select>
          </FormControl>

          {/* Dropdown 2 */}
          <FormControl size="small" sx={{ width: 100 }}>
            <InputLabel
              id="demo-simple-select-label"
              sx={{ fontSize: "0.75rem" }}
            >
              Status
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Status"
              sx={{
                fontSize: "0.75rem",
                "& .MuiInputBase-input": {
                  fontSize: "0.75rem",
                  padding: "6px 8px",
                },
              }}
            >
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="inActive">InActive</MenuItem>
            </Select>
          </FormControl>

          {/* Dropdown 3 */}
        </Box>
        <Box>
          <Button>+ Manage Filter</Button>
        </Box>
      </Box>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ boxShadow: 2 }}>
              <TableCell
                sx={{
                  backgroundColor: "#4694d9",
                  borderRight: "1px solid white",
                  color: "white",
                  textAlign: "center",
                }}
              >
                wabaNumber
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "#4694d9",
                  borderRight: "1px solid white",
                  color: "white",
                  textAlign: "center",
                }}
              >
                Assigned on
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "#4694d9",
                  borderRight: "1px solid white",
                  color: "white",
                  textAlign: "center",
                }}
              >
                Status
              </TableCell>
              <TableCell
                sx={{
                  backgroundColor: "#4694d9",
                  borderRight: "1px solid white",
                  color: "white",
                  textAlign: "center",
                }}
              >
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{ textAlign: "center" }}>91873434534</TableCell>
              <TableCell sx={{ textAlign: "center" }}>11/mar/2025</TableCell>
              <TableCell sx={{ textAlign: "center" }}>Active</TableCell>
              <TableCell sx={{ textAlign: "center" }}>
                <SettingsIcon size="small" />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default WabaNumber;
